module.exports = __webpack_public_path__ + "img/salades.31654d90.jpg";